import secureLocalStorage from "react-secure-storage";
import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import {
  DeleteProduct,
  DeleteSupplier,
  DeleteUser,
  GetEmbalagens,
  GetProduto,
  GetSuppliers,
  GetSuppliersByEmbalagens,
  GetSuppliersByUnity,
  GetTipoEmbalagens,
  GetUsers,
  GetUsersUnidade,
  PostSuppliers,
} from "../../../data/services";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import { toast } from "react-toastify";
import AdicionarFornecedor from "./AdicionarFornecedores";
import EditarFornecedor from "./EditarFornecedores";

const AdminFornecedores = () => {
  const { user } = useAuth();
  const profile = user.profile;

  if (profile === "usuarioFornecedor") window.location.href = "/home";
  const token: any = secureLocalStorage.getItem("access_token");
  if (!token) {
    window.location.href = "/";
  }
  const UnidadeAdmin = "adminUnidade";
  const SuperAdmin = "superAdmin";
  const adm = profile === SuperAdmin || profile === UnidadeAdmin;

  // const [embalagensOption, setEmbalagensOption] = useState<any>([]);
  const [tipoEmbalagens, setTipoEmbalagens] = useState<any>([]);
  const [fornecedoresOptions, setFornecedoresOptions] = useState<any>([]);
  // const [fornecedoresUnidades, setFornecedoresUnidades] = useState<any>([]);
  // const [fornEmbalagens, setFornEmbalagens] = useState<any>([]);

  const [selectedFornecedor, setSelectedFornecedor] = useState<any>(null);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [editFornecedor, setEditFornecedor] = useState<boolean>(false);

  const handleCloseModal = () => {
    setEditFornecedor(false);
    setTimeout(() => {
      window.location.reload();
    }, 50);
  };

  useEffect(() => {
    GetSuppliers(setFornecedoresOptions);
    // GetSuppliersByUnity(setFornecedoresUnidades);
    // GetEmbalagens(setEmbalagensOption);
    GetTipoEmbalagens(setTipoEmbalagens);
    // GetSuppliersByEmbalagens(setFornEmbalagens);
  }, []);

  // useEffect(() => {
  //   const idsEmbalagens = fornEmbalagens.map((item: any) => item.idFornecedor);

  //   const idsUnity = fornecedoresUnidades.map((item: any) => item.idFornecedor);

  //   const FornsUnitys = fornecedoresOptions?.filter((a: any) => {
  //     return idsUnity.includes(a.idFornecedor);
  //   });

  //   const idsForn = fornecedoresOptions?.map((item: any) => item.idFornecedor);

  //   const Units = fornecedoresUnidades?.filter((a: any) => {
  //     return idsForn.includes(a.idFornecedor);
  //   });
  //   FornsUnitys?.filter((item: any) => {
  //     return (
  //       (item.unidades = Units?.filter(
  //         (un: any) => item.idFornecedor === un.idFornecedor
  //       )),
  //       (item.embalagens = fornEmbalagens?.filter(
  //         (em: any) => item.idFornecedor == em.idFornecedor
  //       ))
  //     );
  //   });
  // }, [
  //   fornecedoresOptions,
  //   embalagensOption,
  //   fornEmbalagens,
  //   fornecedoresUnidades,
  // ]);

  async function handleSaveFornecedor(fornecedor: {
    fornecedorDescricao: string;
    cpfCnpj: string;
  }) {
    try {
      await PostSuppliers(fornecedor);
      GetSuppliers(setFornecedoresOptions);
      setOpenAdicionar(false);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const handleConfirmDelete = async () => {
    try {
      await DeleteSupplier(selectedFornecedor.idFornecedor);
      toast.success("Fornecedor deletado com sucesso!");
      setFornecedoresOptions((prev: any[]) =>
        prev.filter(
          (item) => item.idFornecedor !== selectedFornecedor.idFornecedor
        )
      );
    } catch (error) {
      toast.error("Erro ao deletar fornecedor.");
    } finally {
      toggleModal();
    }
  };

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Fornecedor</td>
        {adm && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {fornecedoresOptions
          ?.sort(function (a: any, b: any) {
            if (a.fornecedorDescricao > b.fornecedorDescricao) {
              return 1;
            }
            if (a.fornecedorDescricao < b.fornecedorDescricao) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  flexDirection: "column",
                  padding: 5,
                  borderBottom: "1px solid #dddddd",
                }}
              >
                <tr style={{ display: "flex", width: "100%" }}>
                  <td className="listTd">{item.fornecedorDescricao ?? "~~"}</td>
                  {adm && (
                    <div style={{ display: "flex", flex: 1, marginLeft: 3 }}>
                      <button
                        className="editBtn"
                        onClick={() => {
                          setSelectedFornecedor(item);
                          setEditFornecedor(true);
                        }}
                      >
                        Editar
                      </button>
                      <button
                        className="deleteUserBtn"
                        onClick={() => {
                          setSelectedFornecedor(item);
                          setIsModalOpen(true);
                        }}
                      >
                        Deletar
                      </button>
                    </div>
                  )}
                </tr>
              </div>
            );
          })}
      </>
    );
  }, [fornecedoresOptions]);

  return (
    <div className="modalSignUp">
      <div className="content-header-button-and-title">
        <h1>Fornecedores</h1>

        {adm && (
          <button className="BtnClean" onClick={() => setOpenAdicionar(true)}>
            Adicionar
          </button>
        )}
      </div>

      <div className="contentList">{ListColumns}</div>
      <div className="content">
        <div className="containerListInfo">
          {fornecedoresOptions.length > 0 ? (
            <>{List}</>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                Não há registros aqui
              </h1>
            </div>
          )}
        </div>
      </div>

      {editFornecedor && (
        <EditarFornecedor
          fornecedor={selectedFornecedor}
          tipoEmbalagensOptions={tipoEmbalagens} // você precisa passar essa lista
          onCancel={handleCloseModal}
        />
      )}

      {openAdicionar && (
        <AdicionarFornecedor
          onSave={handleSaveFornecedor}
          onCancel={() => setOpenAdicionar(false)}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedFornecedor?.fornecedorDescricao ?? ""}
      />
    </div>
  );
};
export default AdminFornecedores;
